import React from 'react';
import { SVGProps } from './types';

export const DownloadIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeWidth="1.25"
        d="M10 4.207v8.03M7.5 10.04l2.5 2.5 2.5-2.5"
      />
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M4.167 15.873h11.666"
      />
    </svg>
  );
};
